import { haciendaApi } from "../../api";
import { DteInvalidationLogFilter } from "../../types/hacienda/DteInvalidationLogFilter";

const HaciendaInvalidationLogService = {

  /**
 * 📄 Lista errores de invalidación con búsqueda y paginación
 * POST /api/hacienda/invalidation-logs/search?page=0&size=10&sort=createdAt,desc
 */
  getSearch: async (
    filters: DteInvalidationLogFilter,
    page = 0,
    size = 10,
    sort = "createdAt,desc"
  ) => {
    const response = await haciendaApi.addCustom(
      `/invalidation-logs/search?page=${page}&size=${size}&sort=${sort}`,
      filters
    );

    return response.data;
  },



  /**
   * 🔎 Obtiene el detalle de un registro específico
   * GET /api/hacienda/invalidation-logs/{id}
   */
  getById: async (id: number) => {
    const response = await haciendaApi.fetchCustom(
      `/invalidation-logs/${id}`
    );
    return response.data;
  },

  /**
   * ⬇️ Descarga el JSON enviado a Hacienda
   * GET /api/hacienda/invalidation-logs/{id}/request-json
   */
  downloadRequestJson: async (id: number): Promise<void> => {
    await haciendaApi.downloadJsonFile(
      `/invalidation-logs/${id}/request-json`
    );
  },

  /**
   * ⬇️ Descarga la respuesta cruda recibida desde Hacienda
   * GET /api/hacienda/invalidation-logs/{id}/response-json
   */
  downloadResponseJson: async (id: number): Promise<void> => {
    await haciendaApi.downloadJsonFile(
      `/invalidation-logs/${id}/response-json`
    );
  },
};

export default HaciendaInvalidationLogService;
